import { render, staticRenderFns } from "./ModalFormEventTraining.vue?vue&type=template&id=fc67065e&scoped=true&"
import script from "./ModalFormEventTraining.vue?vue&type=script&lang=js&"
export * from "./ModalFormEventTraining.vue?vue&type=script&lang=js&"
import style0 from "./ModalFormEventTraining.vue?vue&type=style&index=0&id=fc67065e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc67065e",
  null
  
)

export default component.exports